export default __webpack_public_path__ + "static/media/checkbox.1082a286.svg";